import { useState } from "react";
import { serverGql } from "__generated__/serverGql";
import useAsyncCompleteToast from "components/Shared/useAsyncCompleteToast";
import serverClient from "utils/apollo/serverClient";
import { assertPresence } from "utils/assertions";
import { BRAND_BILLING } from "utils/links";

const mutation = serverGql(/* ServerGraphQL */ `
  mutation CreateStripeSubscriptionUpdateSession(
    $brandId: UUID!
    $accessPlanId: UUID!
    $returnUrl: String!
  ) {
    createStripeSubscriptionUpdateSession(
      brandId: $brandId
      accessPlanId: $accessPlanId
      returnUrl: $returnUrl
    ) {
      url
    }
  }
`);

type CreateStripeSubscriptionUpdateSessionParams = {
  accessPlanId: UUID;
  brandId: UUID;
  returnPath?: string;
};

export default function useCreateStripeSubscriptionUpdateSession() {
  const [isLoading, setIsLoading] = useState(false);

  const { showErrorToast } = useAsyncCompleteToast();

  const createStripeSubscriptionUpdateSession = ({
    accessPlanId,
    brandId,
    returnPath,
  }: CreateStripeSubscriptionUpdateSessionParams) => {
    setIsLoading(true);

    serverClient
      .mutate({
        mutation,
        variables: {
          accessPlanId,
          brandId,
          returnUrl: `${window.location.origin}${returnPath ?? BRAND_BILLING}`,
        },
      })
      .then((response) => {
        const url = response.data?.createStripeSubscriptionUpdateSession?.url;
        assertPresence(url, "Expected subscription update URL to be defined");
        window.location.href = url;
      })
      .catch((reason: unknown) => {
        showErrorToast(reason);
        setIsLoading(false);
      });
  };

  return { createStripeSubscriptionUpdateSession, isLoading };
}
